import React,{useEffect} from 'react';
import Footer from '../Footer';
import Header from '../Header';
import SidebarWrapper from '../SidebarWrapper';
import { useLogin } from '../../hooks/useLogin';
export default function MainLayout({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  const { handleAuthenticationFailure } = useLogin();
  useEffect(() => {
    console.log('entered mainlayout');
    void handleAuthenticationFailure();
  },[]);

  return (
    <>
      <SidebarWrapper />
      <div className="flex-1 main-container h-[100%]">
        <Header />
        
        <div className="px-10 py-5 min-h-[87vh] max-h-[100%]">{children}</div>
        <Footer />
      </div>
    </>
  );
}
